// composables/useAuthFlow.ts
import { ref, computed } from 'vue'
import { AuthView } from '~~/layers/base/types/auth'

// if token is expires
const authMessage = ref<string | null>(null)

const authFlowView = ref<AuthView | null>(null)
const isForcedAuth = ref(false)
export function useAuthFlow() {
    const isOpen = computed<boolean>(() => authFlowView.value !== null)

    const authFlowTitle = computed<string>(() => {
        switch (authFlowView.value) {
            case AuthView.Login:
                return 'Login'
            case AuthView.SignUp:
                return 'Sign Up'
            case AuthView.ForgotPassword:
                return 'Forgot Password'
            case AuthView.ResetPasswordWithOtp:
                return 'Reset Password With OTP'
            default:
                return ''
        }
    })

    const open = (view: AuthView, message?: string, forced = false): void => {
        authFlowView.value = view
        authMessage.value = message || null // if token is expires
        isForcedAuth.value = forced // if token is expires
    }

    const close = (): void => {
        authFlowView.value = null
        authMessage.value = null
    }

    const setAuthView = (view: AuthView): void => {
        authFlowView.value = view
    }

    return {
        authFlowView,
        isOpen,
        authFlowTitle,
        authMessage,
        isForcedAuth,
        open,
        close,
        setAuthView,
    }
}
